import React from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { amountUsdToWords } from "../../print/utils/numberToWords";

const PdfPreview = () => {
  const generatePreview = () => {
    const doc = new jsPDF("p", "mm", "a4");

    //add border
    const pageWidth = doc.internal.pageSize.width;
    const margin = 10;

    // Add Title
    doc.setFontSize(14);
    doc.setFont("bold");
    doc.text("COMMERCIAL INVOICE", pageWidth / 2, 10, null, null, "center");

    let x = 10;
    let y = 15;
    doc.rect(x, y, 190, 400);

    doc.rect(x, y, 90, 50); // Left box (x, y, width, height)

    // Add Exporter Details
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("Exporter", x + 3, y + 5);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("M/s Alico Traders and Contractors", x + 3, y + 12);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("9-4-87/B/33, Minar Colony, Tolichowki,", x + 3, y + 17);
    doc.text("Hyderabad, Telangana - 500008, INDIA", x + 3, y + 22);
    doc.text("Email: info@alicotnc.com", x + 3, y + 27);
    doc.text("Contact Person: Mr. MD BASHARATH ALI", x + 3, y + 32);
    doc.text("Mobile: +91 9052477647", x + 3, y + 37);

    doc.rect(x, y + 50, 90, 48);
    // Add Consignee Details
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("Consignee", x + 3, y + 55);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("M/s Walid Ali Almadhi and Partner Co.", x + 3, y + 62);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("Al-Ohali Business Center, 3rd Floor,", x + 3, y + 67);
    doc.text("Dabba Area, DAMMAM-32261, SAUDI ARABIA", x + 3, y + 72);
    doc.text("Email: muhammed.rafi@wamco.com.sa", x + 3, y + 77);
    doc.text("Contact: Muhammad Rafi", x + 3, y + 82);
    doc.text("Mobile: +966-53 113 45 47", x + 3, y + 87);

    x = x + 90;
    y = 15;
    // Invoice Details
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.rect(x, y, 40, 8);
    doc.text("Invoice No: ATC-2035", x + 2, y + 5);

    doc.rect(x, y + 8, 40, 10);
    doc.text("Date: 15-Jan-2025", x + 6, y + 14);

    doc.rect(x + 40, y, 60, 18);
    doc.text("IE Code: ASAPA6292J", x + 48, y + 10);

    doc.rect(x, y + 18, 100, 14);
    doc.setFontSize(9);
    doc.text("Buyers Order No:", x + 2, y + 23);
    doc.setFontSize(10);
    doc.text("24216 && 25244", x + 2, y + 29);
    doc.setFontSize(10);
    doc.text("Dated: 25-Dec-2024", x + 48, y + 23);
    doc.text("Dated: 12-Jan-2025", x + 48, y + 29);

    //Buyer details
    doc.rect(x, y + 32, 100, 30);
    doc.text("Buyer (if other than consignee)", x + 2, y + 39);
    doc.rect(x, y + 62, 100, 12);
    doc.setFontSize(10);
    doc.text("Country of Manufacture : ", x + 2, y + 69);
    doc.text("India", x + 50, y + 69);
    doc.rect(x, y + 85, 100, 13);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Country of Export : ", x + 2, y + 80);
    doc.text("India", x + 50, y + 80);
    doc.rect(x, y + 85, 100, 13);
    doc.text("Country of Final Destination : ", x + 2, y + 92);
    doc.text("Dammam Saudi Arabia", x + 50, y + 92);

    //payment details
    doc.rect(x, y + 98, 100, 35);
    doc.text("Terms of delivery and payment:", x + 2, y + 103);

    //carrier details
    x = 10;
    y = 115;
    doc.rect(x, y - 2, 35, 13);
    doc.text("Pre-Carriage By:", x + 2, y + 4);
    doc.text("Road", x + 5, y + 9);

    doc.rect(x + 35, y - 2, 55, 13);
    doc.text("Place of reciept by pre-carrier:", x + 37, y + 4);

    doc.rect(x, y + 11, 35, 11);
    doc.text("Vessel/flight No:", x + 2, y + 15);

    doc.rect(x + 35, y + 11, 55, 11);
    doc.text("Port of loading:", x + 37, y + 15);

    doc.rect(x, y + 22, 35, 11);
    doc.text("Port of Discharge:", x + 2, y + 27);
    doc.text("Hyderabad", x + 2, y + 30);

    doc.rect(x + 35, y + 22, 55, 11);
    doc.text("Final Destination:", x + 37, y + 27);
    doc.text("Dammam Saudi Arabia:", x + 37, y + 30);

    // // Table Header
    // Example Data
    const tableData = [
      {
        description: "Item 1 - Long text example goes here",
        hsnCode: "12345",
        quantity: 4,
        rate: 100,
        amount: 400,
      },
      {
        description: "Item 2",
        hsnCode: "67890",
        quantity: 2,
        rate: 150,
        amount: 300,
      },
      {
        description: "Item 3 - Another lengthy text that wraps properly",
        hsnCode: "11223",
        quantity: 3,
        rate: 120,
        amount: 360,
      },
    ];

    const headers = [
      ["S.No", "Description", "HSN Code", "Qty", "Rate (USD)", "Amount (USD)"],
    ];

    // Automatically map table rows based on dynamic data
    const bodyData = tableData.map((item, index) => [
      index + 1,
      item.description,
      item.hsnCode,
      item.quantity.toString(),
      item.rate.toString(),
      item.amount.toString(),
    ]);

    let yPosition = y + 37;

    autoTable(doc, {
      startY: yPosition,
      head: headers,
      body: bodyData,
      theme: "grid",
      // Prevent splitting a row across pages. If a row doesn't fit, move it fully to the next page.
      // (If a single row is taller than a page, autoTable will still have to split it.)
      rowPageBreak: "avoid",
      margin: { left: 15, right: 15 },
      styles: {
        fontSize: 10,
        cellPadding: 3,
        overflow: "linebreak",
        tableLineWidth: 0.5,
        tableLineColor: [0, 0, 0],
      },
      columnStyles: {
        1: { cellWidth: 60 }, // For long text wrapping in Description
        4: { halign: "right" }, // Align Rate to the right
        5: { halign: "right" }, // Align Amount to the right
      },
      headStyles: {
        fillColor: [235, 235, 235],
        textColor: [0, 0, 0],
        lineWidth: 0.2, // Add border width for header
        lineColor: [0, 0, 0], // Black grid lines for header
      },
    });

    yPosition = doc.lastAutoTable.finalY + 10;
    doc.setFont("helvetica", "normal");
    // Add total section dynamically based on table data
    const totalQty = tableData.reduce((sum, item) => sum + item.quantity, 0);
    const totalAmount = tableData.reduce((sum, item) => sum + item.amount, 0);

    doc.setFont("helvetica", "bold");
    //doc.rect(91,yPosition-10,27,9);
    //doc.rect(118,yPosition-10,14,9);
    doc.text(`Total Quantity`, 93, yPosition - 5);
    doc.text(totalQty.toString(), 123, yPosition - 5);
    doc.text(`Total Amount (USD):`, 148, yPosition + 7);
    doc.text(totalAmount.toString(), 186, yPosition + 7);
    doc.rect(x + 2, yPosition + 12, 185, 10);
    const totalAmountInWords = amountUsdToWords(totalAmount);
    doc.text(
      `Total Amount in Words: ${totalAmountInWords}`,
      24,
      yPosition + 18
    );

    y = yPosition + 20;
    // doc.rect(x, y, 125, 8);
    // doc.setFontSize(12);
    // doc.text("Total Quantity:  8", x + 75, y + 5);
    // doc.text("Total", x + 155, y + 5);
    // doc.rect(x + 170, y, 20, 8);
    // doc.text("$6200", x + 173, y + 5);
    // doc.rect(x + 153, y + 8, 17, 10);
    // doc.rect(x + 170, y + 8, 20, 10);
    // doc.rect(x, y + 18, 30, 12);
    // doc.text("Total in", x + 2, y + 22);
    // doc.text("words(USD)", x + 2, y + 27);
    // doc.rect(x + 30, y + 18, 118, 12);
    // doc.text("six thousand and two hunderd dollar only/-", x + 40, y + 26);
    // doc.rect(x + 148, y + 18, 18, 12);
    // doc.text("Total", x + 150, y + 25);
    // doc.rect(x + 166, y + 18, 24, 12);
    // doc.text("$6200 ", x + 168, y + 25);

    doc.rect(x, y + 10, 120, 40);
    doc.text("Declaration", x + 5, y + 15);
    doc.setFont("helvetica", "normal");
    const declarationText =
      "We declare that the invoice shows the actual price of goods described and that all particulars are true and correct.";
    const maxWidth = 110; // Adjust for rectangle width with padding
    const lineHeight = 5; // Space between lines
    let yOffset = y + 22; // Initial Y position

    // Split and draw text
    const lines = doc.splitTextToSize(declarationText, maxWidth);
    lines.forEach((line) => {
      if (yOffset <= y + 40) {
        // Limit to fit inside rectangle height
        doc.text(line, x + 5, yOffset);
        yOffset += lineHeight;
      }
    });
    doc.text("We intend to claim rewards under", x + 5, y + 37);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("RODTEP", x + 5, y + 42);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("Scheme", x + 25, y + 42);

    doc.rect(x + 120, y + 10, 70, 25);
    doc.text("Company's PAN : ASAPA6292J", x + 122, y + 16);
    doc.text("Company's GST : 36ASAPA6292JIZQ", x + 122, y + 21);
    doc.text("Company's LUT : ASAPA54fYY2J", x + 122, y + 26);
    doc.rect(x + 120, y + 35, 70, 15);
    doc.text("Signature and Co. Stamp", x + 135, y + 48);

    const pdfDataUrl = doc.output("dataurlstring");

    // Display in an iframe
    const iframe = document.getElementById("pdfPreview");
    if (iframe) {
      iframe.src = pdfDataUrl;
    }
  };

  return (
    <div>
      <button
        onClick={generatePreview}
        style={{
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          marginBottom: "10px",
        }}
      >
        Preview PDF
      </button>
      <iframe
        id="pdfPreview"
        style={{
          width: "100%",
          height: "500px",
          border: "1px solid #ccc",
        }}
        title="PDF Preview"
      ></iframe>
    </div>
  );
};

export default PdfPreview;
